import {
  APP_ROUTE_PATIENT_APPOINTMENTS,
  APP_ROUTE_PATIENT_CHARTS,
  APP_ROUTE_PATIENT_MEDICATIONS,
  APP_ROUTE_PATIENT_MESSAGES,
  APP_ROUTE_PATIENT_PROFILE,
  APP_ROUTE_PATIENT_RESULTS,
  APP_ROUTE_PATIENT_SETTINGS,
  APP_ROUTE_PATIENT_SUPPORT
} from '@/src/constants/patientRoutes'
import patientAvatar from '@images/patient_avatar.png'
import { NotificationBell } from '@/src/notifications'
import { PATIENT_MODAL_TYPE, useModalStore } from '@modal'
import { Button } from '@ui'
import { Box, Text } from 'grommet'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useProfile } from '../../zustand/store'

type PatientNavConfig = {
  title: string
  button?: {
    label: string
    onClick: () => void
  }
}

const PatientNavbar = () => {
  const { pathname } = useLocation()
  const { openModal } = useModalStore()
  const { user } = useProfile()

  const nav = useMemo<PatientNavConfig>(() => {
    const openAppointmentModal = () => {
      openModal(PATIENT_MODAL_TYPE.CREATE_APPOINTMENT, {})
    }

    const routeNavConfig: Record<string, PatientNavConfig> = {
      '/': { title: 'Dashboard', button: { label: 'Add Appointment', onClick: openAppointmentModal } },
      [APP_ROUTE_PATIENT_APPOINTMENTS]: {
        title: 'Appointment',
        button: { label: 'Add Appointment', onClick: openAppointmentModal }
      },
      [APP_ROUTE_PATIENT_CHARTS]: {
        title: 'Chart',
        button: { label: 'Book appointment', onClick: openAppointmentModal }
      },
      [APP_ROUTE_PATIENT_RESULTS]: {
        title: 'Results',
        button: { label: 'Book appointment', onClick: openAppointmentModal }
      },
      [APP_ROUTE_PATIENT_MEDICATIONS]: {
        title: 'Medications',
        button: { label: 'Book appointment', onClick: openAppointmentModal }
      },
      [APP_ROUTE_PATIENT_MESSAGES]: { title: 'Messages' },
      [APP_ROUTE_PATIENT_PROFILE]: { title: 'Profile' },
      [APP_ROUTE_PATIENT_SETTINGS]: { title: 'Settings' },
      [APP_ROUTE_PATIENT_SUPPORT]: { title: 'Support' }
    }

    return routeNavConfig[pathname] || routeNavConfig['/']
  }, [openModal, pathname])
  const isDashboard = pathname === '/'

  return (
    <div className="flex min-w-0 flex-1 items-center justify-between gap-4">
      {isDashboard ? (
        <Box className="min-w-0">
          <Text color="#000000" size="24px" weight={600}>
            {`Welcome back, ${user?.first_name || 'Patient'}`}
          </Text>
          <Text color="#666666" size="small">
            Your health is your greatest treasure.
          </Text>
        </Box>
      ) : (
        <h1 className="truncate text-xl font-semibold text-[#131520]">{nav.title}</h1>
      )}

      <div className="flex shrink-0 items-center gap-3">
        {nav.button ? (
          <Button onClick={nav.button.onClick} size="md">
            {nav.button.label}
          </Button>
        ) : null}
        <NotificationBell audience="patient" />
        <div className="flex size-7 cursor-pointer items-center justify-center rounded-full bg-[#F0F0F0]">
          <img alt="patient avatar" className="size-full rounded-full object-cover" src={patientAvatar} />
        </div>
      </div>
    </div>
  )
}

export default PatientNavbar
